import { makeStyles } from 'tss-react/mui';

const useStylesHeaderSubmenuHelper: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  headerSubmenuHelper: {
    position: 'absolute',
    background: theme.palette.primary.light,
    height: 16,
    width: 54,
    top: 48,
    [theme.breakpoints.down('md')]: {
      width: 44,
    },
    [theme.breakpoints.down('sm')]: {
      width: 34,
    },
  },
}));

export default useStylesHeaderSubmenuHelper;
